module.exports = __webpack_public_path__ + "static/media/12.2a2abab5.png";